import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@bibliocommons/heading';

import BackLink from '../BackLink';

import './FatalErrorPage.scss';

const FatalErrorPage = ({ backLinkLabel, backLinkUrl, heading }) => {
  return (
    <div className="cp-admin-browse-fatal-error-page container">
      <div className="row">
        <div className="col-12">
          <BackLink className="back-link" dataKey="back-link" label={backLinkLabel} url={backLinkUrl} />
          <Heading className="heading" size="large" tagName="h1" variant>
            {heading}
          </Heading>
          <p>Something went wrong loading this page.</p>
        </div>
      </div>
    </div>
  );
};

FatalErrorPage.propTypes = {
  backLinkLabel: PropTypes.string.isRequired,
  backLinkUrl: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired
};

export default FatalErrorPage;
